export default __webpack_public_path__ + "static/media/TSHARE.294c969b.svg";